/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Fix: Popular search linklerinde gerçek URL varsa oraya git, arama yapma
  document.addEventListener('click', function(event) {
    var link = event.target.closest('[data-popular-searches-link]');
    if (link) {
      var href = link.getAttribute('href');
      if (href && href !== '' && !href.includes('/search')) {
        event.stopPropagation();
        event.preventDefault();
        window.location.href = href;
      }
    }
  }, true);







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
